import { useState } from "react";
import classNames from "classnames";
import { useAsyncDebounce, FilterValue } from "react-table";
import { Button, SplitButton } from "react-bootstrap";

type GlobalFilterProps = {
    preGlobalFilteredRows: any;
    globalFilter: any;
    setGlobalFilter: (filterValue: FilterValue) => void;
    searchBoxClass?: string;
    totalRows?: number;
    searchOnChange?: any
    keywordChange?: (keyword: any) => void;
    searchPlaceHolder?: string;
    customSearchButton?: React.ReactNode;
};

const GlobalFilter = ({ preGlobalFilteredRows, globalFilter, setGlobalFilter, searchBoxClass, totalRows, keywordChange, searchOnChange, searchPlaceHolder, customSearchButton }: GlobalFilterProps) => {
    const customSearch = customSearchButton || null;
    const [value, setValue] = useState<any>(globalFilter);
    const [displayMenu, setDisplayMenu] = useState(false);
    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined);
        keywordChange && keywordChange(value || undefined);
    }, 200);

    const handleKeyPress = (event: any) => {
        if (event.key === "Enter") {
            searchOnChange(value);
            keywordChange && keywordChange(value);
        }
    };

    const onSearchChange = (value:string) => {
        setValue(value);
        keywordChange && keywordChange(value);
    };

    return (
        <div className="search">
            <div className={classNames(searchBoxClass, "search-container")}>
                <span className="d-flex align-items-center">
                    <input
                        value={value || ""}
                        onChange={(e) => onSearchChange(e.target.value)}
                        onKeyDown={handleKeyPress}
                        placeholder={`Search ${totalRows} records ${searchPlaceHolder}`}
                        className="form-control w-auto ms-1"
                    />
                </span>
            </div>
            {customSearch ?
                <SplitButton
                    variant="primary"
                    title="Search"
                    onClick={() => searchOnChange(value)}
                    className="custom-search-button me-1"
                    show={displayMenu}
                    autoClose="outside"
                    onToggle={() => setDisplayMenu(!displayMenu)}
                >  {customSearch} </SplitButton>
                :
                <Button 
                    variant="primary" 
                    className="btn-icon me-1 custom-btn-icon filter-btn" 
                    onClick={() => searchOnChange(value)}
                >Search</Button>
            }
        </div>
    );
};

export default GlobalFilter;